<!--
Crea un contenedor responsive con una imagen de fondo de un tablero y
cuyos contenidos se ajustan al tamaño y permiten ser alineados fácilmente
TENER EN CUENTA QUE EL COMPONENTE EMPIEZA CON FLEX. 
POR LO GENERAL HAY QUE INSTANCIARLO DENTRO DE UN <V-LAYOUT></V-LAYOUT>

El tablero en celulares se ajusta al tamaño del contenido, en el resto de dispositivos 
la idea es que el contenido se ajuste dentro del tamaño del tablero. Se puede desactivar
el comportamiento para celulares en casos espacíficos (Ej: imágenes que dependan de la
altura del padre) pasando el parametro responsive como false.
-->
<template>
    <v-flex :class="{'responsive':responsive}" class="div-tablero">
        <div class="tablero">
            <img :class="{'hidden-xs-only':responsive}" :src="imgTablero" alt="">
            <div class="contenido-tablero">
                <slot></slot>
            </div>
        </div>
    </v-flex>
</template>
<script>

    export default {

        props: {
            responsive: {
                type: Boolean,
                default: true,
                required: false
            }
        },
        data() {
            return {
                imgTablero: '',
            }
        },
        created() {
            var self = this
            this.getSvg('styleguide/tablero', data => {
                self.imgTablero = data
            })
        }
    }
</script>
<style class="scoped" lang="scss">
    .div-tablero {
        max-width: calc(175vh * 9 / 16);
        position: relative;
        // @media (max-width: 600px){
        //   position: static;
        // }
    }

    .tablero {
        width: 100%;

        // La posición relativa ayuda a situar el contenido correctamente
        position: relative;

        //Se desabilita para la vista de celulares
        // @media (max-width: 600px) {
        //   position: static;
        //   min-height: 50px;
        //   padding: 10px 5px;
        //   border: 4px solid #5b3f09;
        //   background-color: white;
        // }

        // Imágen del tablero
        > img {
            width: 100%;
            position: relative;
        }

    }

    .contenido-tablero {
        position: absolute;
        top: 5%;
        left: 5%;
        width: 90%;
        height: 88%;
        background-color: white;
        // @media (max-width: 600px) {
        //   position: static;
        //   margin: auto;
        // }
    }

    .responsive {
        &.div-tablero {
            @media (max-width: 600px) {
                position: static;
            }
        }

        .tablero {
            //Se desabilita para la vista de celulares
            @media (max-width: 600px) {
                position: static;
                min-height: 50px;
                padding: 10px 5px;
                border: 4px solid #5b3f09;
                background-color: white;
            }
        }

        .contenido-tablero {
            @media (max-width: 600px) {
                position: static;
                margin: auto;
            }
        }
    }

</style>
